export const SOCKET_CONNECTION_STATUS = {
	ONLINE: 'ONLINE',
	CONNECTING: 'CONNECTING',
	OFFLINE: 'OFFLINE',
}

/**
 * STOMP deactivate 在背景已死的 socket 上可能一直不 resolve，前景重連不可被它卡住。
 */
export const STOMP_DEACTIVATE_TIMEOUT_MS = 1500

export function withTimeoutSettle(promise, ms) {
	if (promise == null) return Promise.resolve()
	return Promise.race([
		Promise.resolve(promise).catch(() => {}),
		new Promise(resolve => setTimeout(resolve, ms)),
	])
}

/**
 * 前景恢復：實際已連才略過。連線中或 stomp 已死則立刻重連，不要等心跳或退避。
 */
export function shouldReconnectOnForeground({ isConnected, stompConnected }) {
	return !(isConnected && stompConnected)
}

/**
 * 回前景時只提示「原本連過但在背景斷線」或狀態仍在線但 STOMP 已失效的情況。
 */
export function shouldNotifyDisconnectOnForeground({
	isConnected,
	stompConnected,
	disconnectedWhileInactive,
}) {
	return (
		disconnectedWhileInactive === true ||
		(isConnected === true && stompConnected !== true)
	)
}

/**
 * 背景不排自動重連，避免重試上限把人登出；回來由 ensureConnected 立刻補連。
 */
export function shouldScheduleReconnectOnClose({ wantConnected, isAppActive }) {
	return wantConnected === true && isAppActive === true
}

/**
 * 斷線期間的推播補不回來，只能在重連成功後重取。首次連線沒有漏收問題，不必補。
 */
export function shouldRefreshMenuAfterReconnect(missedPushWindow, pathname) {
	return (
		missedPushWindow === true && pathname?.startsWith('/store-pos') === true
	)
}

/**
 * 相容既有字串 payload，並讓切店等預期重建流程明確抑制斷線提示。
 */
export function resolveSocketActionOptions(payload) {
	if (typeof payload === 'string') {
		return {
			reason: payload || '未標記來源',
			suppressDisconnectNotice: false,
		}
	}
	return {
		reason: payload?.reason || '未標記來源',
		suppressDisconnectNotice: payload?.suppressDisconnectNotice === true,
	}
}

export function shouldShowDisconnectNotice({
	isConnected,
	suppressDisconnectNotice,
}) {
	return isConnected === true && suppressDisconnectNotice !== true
}

/**
 * 實際連上才算 ONLINE；仍要維持連線但還沒連上則為 CONNECTING。
 */
export function getSocketConnectionStatus({ isConnected, wantConnected }) {
	if (isConnected) return SOCKET_CONNECTION_STATUS.ONLINE
	if (wantConnected) return SOCKET_CONNECTION_STATUS.CONNECTING
	return SOCKET_CONNECTION_STATUS.OFFLINE
}

/**
 * 印表機已在線就亮綠燈，不因 socket 重連中把已連的燈壓成黃燈。
 */
export function resolvePrinterLightStatus(socketStatus, printerStatus) {
	if (socketStatus === SOCKET_CONNECTION_STATUS.OFFLINE) {
		return SOCKET_CONNECTION_STATUS.OFFLINE
	}
	if (printerStatus === SOCKET_CONNECTION_STATUS.ONLINE) {
		return SOCKET_CONNECTION_STATUS.ONLINE
	}
	if (socketStatus === SOCKET_CONNECTION_STATUS.CONNECTING) {
		return SOCKET_CONNECTION_STATUS.CONNECTING
	}
	return printerStatus || SOCKET_CONNECTION_STATUS.OFFLINE
}

export function resolvePrinterLinkLabel(socketStatus, isPrinterOn) {
	if (socketStatus === SOCKET_CONNECTION_STATUS.OFFLINE) {
		return '未連線'
	}
	if (isPrinterOn) {
		return '已連線'
	}
	if (socketStatus === SOCKET_CONNECTION_STATUS.CONNECTING) {
		return '連線中'
	}
	return '未連線'
}
